import _KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
var _templateObject;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React, { forwardRef, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { COLORS, FONTS, SIZES, Typography } from '@fupa/fupa-uikit';
import { ButtonContainer, DEFAULT_ICON_STYLES } from 'app/components/tv/customControls/SharedCustomControlsStyles';
import { PlaybackToggle } from 'app/components/tv/customControls/PlaybackToggle';
import { MuteToggle } from 'app/components/tv/customControls/MuteToggle';
import { Button } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { selectAuthState } from 'app/hooks/reduxCreateSelectorHooks';
import { useSelector } from 'react-redux';
import { getPermission } from 'app/services/api';
import { trackVideoProgress } from 'app/components/tv/helpers/trackVideoProgress';
const MUIButton = muiStyled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex!important;\n  font-family: ", ";\n  font-weight: bold;\n  box-sizing: content-box!important;\n  background: transparent!important;\n  color: ", ";\n  border: 1px solid ", "!important;\n  font-size: 0.875rem!important;\n  line-height: 1.75!important;\n  text-transform: uppercase!important;\n   &:hover {\n    background-color: rgba(255, 255, 255, 0.4)!important;\n  },\n\n"])), FONTS.PTSans, COLORS.white, COLORS.white);
const Wrapper = styled.div.withConfig({
  componentId: "sc-1q7jwyc-0"
})(["position:fixed;width:100%;height:100%;z-index:10000;display:flex;flex-direction:column;background:linear-gradient(rgba(0,0,0,0.4) 0%,rgba(0,0,0,1) 100%);padding-bottom:", ";"], SIZES['24']);
const Header = styled.div.withConfig({
  componentId: "sc-1q7jwyc-1"
})(["padding:", ";display:flex;flex-direction:column;"], SIZES['16']);
const Controls = styled.div.withConfig({
  componentId: "sc-1q7jwyc-2"
})(["display:flex;justify-content:space-between;font-size:", ";@media only screen and (max-width:600px){font-size:", ";}"], SIZES['24'], SIZES['16']);
const FlexContainer = styled.div.withConfig({
  componentId: "sc-1q7jwyc-3"
})(["display:flex;align-items:center;"]);
const CurrentVideo = styled.div.withConfig({
  componentId: "sc-1q7jwyc-4"
})(["display:flex;align-items:center;overflow:hidden;"]);
const TextContainer = styled.div.withConfig({
  componentId: "sc-1q7jwyc-5"
})(["display:flex;flex-direction:column;white-space:nowrap;overflow:hidden;"]);
const MainText = styled(Typography).withConfig({
  componentId: "sc-1q7jwyc-6"
})(["font-size:", ";line-height:", ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;@media only screen and (max-width:600px){font-size:", ";line-height:", ";}"], FONTS['18'], FONTS['24'], SIZES['14'], FONTS['20']);
const Caption = styled(Typography).withConfig({
  componentId: "sc-1q7jwyc-7"
})(["color:", ";font-size:", ";line-height:", ";@media only screen and (max-width:600px){font-size:", ";line-height:", ";}"], COLORS.white, FONTS['14'], SIZES['16'], FONTS['10'], SIZES['12']);
const TitleContainer = styled.div.withConfig({
  componentId: "sc-1q7jwyc-8"
})(["display:flex;flex-direction:column;margin-top:", ";padding-left:", ";@media only screen and (max-width:600px){margin-top:", ";}"], SIZES['24'], SIZES['24'], SIZES['16']);
const Title = styled.div.withConfig({
  componentId: "sc-1q7jwyc-9"
})(["display:flex;align-items:flex-end;justify-content:space-between;"]);
const TitleText = styled(Typography).withConfig({
  componentId: "sc-1q7jwyc-10"
})(["font-size:", ";line-height:", ";font-weight:bold;@media only screen and (max-width:600px){line-height:", ";font-size:", ";}"], FONTS['20'], SIZES['28'], SIZES['24'], SIZES['16']);
const PlaylistLength = styled(TitleText).withConfig({
  componentId: "sc-1q7jwyc-11"
})(["font-size:", ";line-height:", ";margin-left:", ";font-weight:normal;color:", ";"], SIZES['14'], SIZES['20'], SIZES['16'], COLORS.grey);
const TitleCaption = styled(Typography).withConfig({
  componentId: "sc-1q7jwyc-12"
})(["font-size:", ";line-height:", ";color:", ";@media only screen and (max-width:600px){line-height:", ";font-size:", ";}"], FONTS['16'], SIZES['20'], COLORS.grey, SIZES['16'], SIZES['12']);
const PlaylistContainer = styled.div.withConfig({
  componentId: "sc-1q7jwyc-13"
})(["display:flex;flex-direction:column;overflow:scroll;padding:0 ", ";"], SIZES['32']);
const PlaylistElement = styled.div.withConfig({
  componentId: "sc-1q7jwyc-14"
})(["display:flex;padding:", " ", ";height:", ";width:100%;align-items:center;cursor:pointer;background-color:", ";&:hover{background-color:rgba(255,255,255,0.3);}"], SIZES['12'], SIZES['16'], SIZES['64'], props => props.isCurrentVideo ? 'rgba(255,255,255,0.3)' : 'transparent');
const PlaylistPosition = styled(MainText).withConfig({
  componentId: "sc-1q7jwyc-15"
})(["margin-right:", ";min-width:", ";text-align:center;"], SIZES['16'], SIZES['24']);
const getPlaylistTitle = match => {
  if (!(match !== null && match !== void 0 && match.homeTeam) || !(match !== null && match !== void 0 && match.awayTeam)) {
    return 'Alle Videos der Playlist';
  }
  return "".concat(match.homeTeam.getTeamName(), " gegen ").concat(match.awayTeam.getTeamName());
};
export const PlaylistOverlay = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    onClose,
    video,
    playlist,
    playerRef,
    playerReady,
    adPlaying,
    playlistFinished,
    setPlaylistFinished,
    currentVideoIndex,
    playlistController,
    ...props
  } = _ref;
  const isAuthenticated = useSelector(selectAuthState);
  const [isAuthorised, setIsAuthorised] = useState(false);
  const playlistTitle = useMemo(() => getPlaylistTitle(video.match), [video.match]);

  // check permission for edit button
  useEffect(() => {
    const playlistId = playlist.getPlaylistId();
    if (!isAuthorised) {
      getPermission('playlist', playlistId).then(response => {
        var _response$data;
        return setIsAuthorised((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.edit);
      }).catch(error => {
        if (error.status === 401) {
          setIsAuthorised(false);
        }
      });
    } else {
      // handle log-out on Playlist-Page
      if (!isAuthenticated && isAuthorised) {
        setIsAuthorised(false);
      }
    }
  }, [playlist, isAuthenticated]);
  const handleEdit = () => {
    const url = playlist.getEditUrl();
    window.open(url);
  };
  const PlaylistEditBtn = isAuthorised ? /*#__PURE__*/React.createElement(MUIButton, {
    onClick: handleEdit,
    variant: "outlined",
    size: "small"
  }, "Bearbeiten") : null;
  const handlePlaylistElementClick = index => {
    const player = playerRef.current;
    if (player) {
      trackVideoProgress(video, player.played());
    }
    playlistController.loadPlaylistItem(index, {
      loadPoster: true
    });
    setPlaylistFinished(false);
    onClose();
  };
  const playlistElements = playlist.getVideos().map((elem, index) => {
    return /*#__PURE__*/React.createElement(PlaylistElement, {
      key: elem.slug,
      onClick: () => handlePlaylistElementClick(index),
      isCurrentVideo: index === currentVideoIndex
    }, /*#__PURE__*/React.createElement(PlaylistPosition, {
      variant: "title1"
    }, index + 1), /*#__PURE__*/React.createElement(TextContainer, null, /*#__PURE__*/React.createElement(MainText, {
      variant: "title1"
    }, elem.title), /*#__PURE__*/React.createElement(Caption, {
      variant: "caption1"
    }, elem.actionType)));
  });
  return /*#__PURE__*/React.createElement(Wrapper, {
    ref: ref
  }, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(Controls, null, /*#__PURE__*/React.createElement(CurrentVideo, null, /*#__PURE__*/React.createElement(ButtonContainer, {
    onClick: onClose
  }, /*#__PURE__*/React.createElement(_KeyboardArrowDown, {
    style: DEFAULT_ICON_STYLES
  })), /*#__PURE__*/React.createElement(TextContainer, null, /*#__PURE__*/React.createElement(MainText, {
    variant: "title1"
  }, video.title), /*#__PURE__*/React.createElement(Caption, {
    variant: "caption1"
  }, video.actionType))), /*#__PURE__*/React.createElement(FlexContainer, null, !playlistFinished ? /*#__PURE__*/React.createElement(PlaybackToggle, {
    playerRef: playerRef,
    playerReady: playerReady,
    adPlaying: adPlaying,
    noMargin: true
  }) : null, /*#__PURE__*/React.createElement(MuteToggle, _extends({}, props, {
    labeled: false
  })))), /*#__PURE__*/React.createElement(TitleContainer, null, /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TitleText, {
    variant: "title1"
  }, playlistTitle), /*#__PURE__*/React.createElement(PlaylistLength, {
    variant: "title1"
  }, currentVideoIndex + 1, "/", playlist.length())), PlaylistEditBtn), /*#__PURE__*/React.createElement(TitleCaption, {
    variant: "caption1"
  }, playlist.getCreatorName()))), /*#__PURE__*/React.createElement(PlaylistContainer, null, playlistElements));
});